import { Box } from 'ui/box';

import { Loader } from 'ui/loader';
import { Typography } from 'ui/typography';
import EmptySpaceContent from 'components/partials/empty-space-content/empty-space-content';
import ResponsiveWrapper from 'components/shared/others/responsive-wrapper/responsive-wrapper';
import FavoriteReportTile from './farovite-report-tile/farovite-report-tile';

import { useFavoriteReports } from 'hooks/api/use-favorite-reports';

import useProductTypesDictionary from '../use-product-types-dictionary';

import type { FavoriteReportData } from './farovite-report-tile/farovite-report-tile';

const FavoriteReports = (): React.JSX.Element => {
  const { dictionary: productTypesDictionary } = useProductTypesDictionary();
  const { data: favoriteReports, loading } = useFavoriteReports();

  const favoriteReportsList = favoriteReports as
    | FavoriteReportData[]
    | null
    | undefined;

  return (
    <ResponsiveWrapper customClass="py-4 px-6">
      <Typography data-testid="my-favorites-heading" variant="h1">
        Favorites
      </Typography>

      <Box sx={{ mt: 2.5 }}>
        {!favoriteReportsList?.length && !loading && (
          <EmptySpaceContent
            customClass="h-[55vh]"
            text="You don't have any favorites saved yet. Navigate to reports to create your first favorite!"
          />
        )}

        {loading ? (
          <Loader loading backdrop="transparent" />
        ) : (
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
              gap: 2,
              '@media (min-width: 960px)': {
                gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
              },
              '@media (min-width: 1280px)': {
                gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
              },
              '@media (min-width: 1440px)': {
                gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
              },
              '@media (min-width: 1600px)': {
                gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
              },
            }}
          >
            {favoriteReportsList?.map((favoriteReport) => (
              <FavoriteReportTile
                key={favoriteReport.id}
                favoriteReport={favoriteReport}
                productTypesDictionary={productTypesDictionary}
              />
            ))}
          </Box>
        )}
      </Box>
    </ResponsiveWrapper>
  );
};

export default FavoriteReports;
